<template>
	<DjBox>
		<a :href="videoUrl" target="_blank">
			<img
				class="max-w-full rounded-t-2xl overflow-hidden"
				:alt="title"
				:src="videoData.thumbnailUrl"
				v-if="videoData.thumbnailUrl"
			/>
		</a>
		<h3 class="p-3 md:pt-7 md:pb-6 md:px-6 text-lg md:text-xl font-medium">{{ title }}</h3>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DjBox from "./DjBox.vue";
import { useVideoParser } from "../../composables/useVideoParser";

export default defineComponent({
	name: "DjBoxPhoto",
	components: {
		DjBox,
	},
	props: {
		title: {
			type: String,
			default: "",
			required: true,
		},
		videoType: {
			type: String,
			default: "",
			required: true,
		},
		videoId: {
			type: String,
			default: "",
			required: true,
		},
		videoUrl: {
			type: String,
			default: "",
			required: true,
		},
	},
	setup(props) {
		const { videoData } = useVideoParser(props.videoUrl);

		return {
			videoData,
		};
	},
});
</script>
